import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Analyze from "@/pages/Analyze";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Gallery from "@/pages/Gallery";
import StyleDetail from "@/pages/StyleDetail";
import Favorites from "@/pages/Favorites";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Profile from "@/pages/Profile";
import Occasion from "@/pages/Occasion";
import OccasionAnalyze from "@/pages/OccasionAnalyze";
import OccasionResult from "@/pages/OccasionResult";

function AppRouter() {
  const location = useLocation();
  // Race-condition guard: detect OAuth callback synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/analyze" element={<ProtectedRoute><Analyze /></ProtectedRoute>} />
        <Route path="/analysis/:id" element={<ProtectedRoute><AnalysisDetail /></ProtectedRoute>} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/style/:id" element={<StyleDetail />} />
        <Route path="/favorites" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
        <Route path="/occasion" element={<ProtectedRoute><Occasion /></ProtectedRoute>} />
        <Route path="/occasion/new" element={<ProtectedRoute><OccasionAnalyze /></ProtectedRoute>} />
        <Route path="/occasion/:id" element={<ProtectedRoute><OccasionResult /></ProtectedRoute>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => { document.title = "Style Me Perfectly! — Your AI Hairstyle & Ceremony Atelier"; }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors theme="dark" position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
